import React from 'react';
import PropTypes from 'prop-types';

const DropdownList = ({
  onClick,
  renderOption = o => o.title,
  options,
  selected,
}) => {
  function handleOptionClick(option) {
    onClick(option);
  }
  return (
    <div className="dropdown-list panel">
      {options
        .filter(o => o.value !== selected)
        .map(option => (
          <button
            type="button"
            className="dropdown-list__option"
            key={option.value}
            onClick={() => handleOptionClick(option)}
          >
            {renderOption(option)}
          </button>
        ))}
    </div>
  );
};

DropdownList.propTypes = {
  /** Mouse click handler. */
  onClick: PropTypes.func,
  /** Mapped over the items and returns element to render in the list */
  renderOption: PropTypes.func,
  /** Array of list items */
  options: PropTypes.arrayOf(PropTypes.shape({
    /** A unique id of the option */
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    /** Title */
    title: PropTypes.string,
    /** Optional object */
    data: PropTypes.shape(),
  })),
  /** Currently selected item */
  selected: PropTypes.string,
};

DropdownList.defaultProps = {
  selected: '',
  options: [],
  onClick: () => {},
  renderOption: o => o.title,
};

export { DropdownList };
